import { useMutation } from '@tanstack/react-query';
import { defenderService } from '@services';
import { showToast } from '@/utils';

interface UseUpgradeDefenderOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useUpgradeDefender = (options?: UseUpgradeDefenderOptions) => {
  return useMutation({
    mutationFn: async (defenderId: number) => {
      console.log('[useUpgradeDefender] Upgrading defender:', defenderId);
      return await defenderService.upgradeDefender(defenderId);
    },
    onSuccess: (data) => {
      console.log('[useUpgradeDefender] ✅ Upgrade successful:', data);
      showToast.success('Defender upgraded successfully!', {
        style: {
          background: '#4CAF50',
          color: '#fff',
        },
      });
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      console.error('[useUpgradeDefender] ❌ Upgrade failed:', error);
      showToast.error(error.message || 'Failed to upgrade defender', {
        style: {
          background: '#f44336',
          color: '#fff',
        },
        duration: 5000,
      });
      options?.onError?.(error);
    },
  });
};
